import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IErrorResponseBody } from '@app/core/models/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        const error: IErrorResponseBody = {
          error: err.error,
          status: err.status,
          code: err.error ? err.error.resultCode : null,
          message: err.error ? err.error.errorMsg : null,
          url: err.url,
        };
        return throwError(error);
      }),
    );
  }
}
